import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { FailResponse } from 'api/evisaAPI/dlAPI'

type State = { errorMessage?: string } & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  errorMessage: '',
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.VERIFY_PASSWORD_ASYNC,
    Actions.VERIFY_PASSWORD_SUCCESS,
    Actions.VERIFY_PASSWORD_FAIL,
    {},
    FailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.VERIFY_PASSWORD_ASYNC:
    case Actions.VERIFY_PASSWORD_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.VERIFY_PASSWORD_FAIL: {
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.error.message || '',
      }
    }
    default:
      return state
  }
}
